/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectCompanyFieldDto } from '../../models/backend-project-company-field-dto';

export interface ProjectsProjectCompanyRetrieve$Params {
  id: number;
}

export function projectsProjectCompanyRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectCompanyRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectCompanyRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectCompanyFieldDto>;
    }),
  );
}

projectsProjectCompanyRetrieve.PATH = '/api/projects/project_company/{id}/';
